/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagRemediationStatus {
    getFixupPrototypeFunction() { return TagRemediationStatus.fixupPrototype; }

    static newInstance(model: Partial<TagRemediationStatus>): TagRemediationStatus {
        let obj = Object.assign(new TagRemediationStatus(), model);
        TagRemediationStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagRemediationStatus>): TagRemediationStatus {
        if (!model) return null;
        return TagRemediationStatus.newInstance(<TagRemediationStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagRemediationStatus) {
        if (!obj) return;

        models.TagRemediationStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagRemediationStatus): boolean {
        Object.setPrototypeOf(obj, TagRemediationStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Status of Tag Remediation
     */
    status: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Created datetime for the Tags
     */
    created_at: Date;

}
